import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { UndefinedConditionTag } from '@portal-core/reports/models/undefined-condition-tags.model';

@CollectionStateSelectors({
  stateType: ProjectReportsUndefinedConditionTagsDataState
})
@State<ProjectReportsUndefinedConditionTagsDataState>({
  name: ProjectReportsUndefinedConditionTagsDataState.source
})
@Service({ autoProvided: false })
export class ProjectReportsUndefinedConditionTagsDataState extends CollectionStateBase {
  static override source = 'ProjectReportsUndefinedConditionTags';
  getSource(): string {
    return ProjectReportsUndefinedConditionTagsDataState.source;
  }
}

@Service()
export class ProjectReportsUndefinedConditionTagsDataService extends CollectionDataServiceBase<UndefinedConditionTag> {
  protected readonly stateType = ProjectReportsUndefinedConditionTagsDataState;
}
